import { scrollToElement } from './functions/lenis-scroll';

export const initFooterAccordion = () => {
    const accordionToggles = document.querySelectorAll(
        '.js-footer-accordion-toggle'
    );

    accordionToggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
            const content = toggle.nextElementSibling;
            const icon = toggle.querySelector('.js-footer-accordion-icon');

            if (
                content &&
                content.classList.contains('js-footer-accordion-content')
            ) {
                content.classList.toggle('hidden');
                if (icon) {
                    icon.style.transform = content.classList.contains('hidden')
                        ? 'rotate(0deg)'
                        : 'rotate(180deg)';
                }
            }
        });
    });
};

export const initFooterMenuAnchorOffset = () => {
    const links = document.querySelectorAll('#menu-co-oferujemy a[href*="#"]');

    if (!links.length) {
        return;
    }

    links.forEach(link => {
        link.addEventListener('click', event => {
            const href = link.getAttribute('href') || '';

            if (!href.includes('#')) {
                return;
            }

            const parsedUrl = new URL(href, window.location.href);
            const isSamePage =
                parsedUrl.origin === window.location.origin &&
                parsedUrl.pathname === window.location.pathname;

            if (!isSamePage || !parsedUrl.hash) {
                return;
            }

            const target = document.querySelector(parsedUrl.hash);
            if (!target) {
                return;
            }

            event.preventDefault();

            const offset = 96;
            scrollToElement(target, offset);

            history.pushState(null, '', parsedUrl.hash);
        });
    });
};
